import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_supports-color@7.2.0__@types+node@25.9.9_react-dom@19.3._e86a5f44176ef8a7c7e437919c0f0628/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/blockchain.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/loader.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/router.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/providers/theme.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/toaster.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
